<script>
  import _ from 'lodash'
  import $ from '../plugins/vue-gridform/shared/helper'
  import { appComputed } from '@state/helpers'
  import { ATYPES } from '@src/plugins/vue-gridform/state/types'
  import CONSTANTS from '@src/constants'
  import Radar from '@components/radar'

  export default {
    name: 'CoachingCompare',
    components: {Radar},
    props: {
      name: {
        type: String,
        default: () => 'coachingCompare'
      },
      rows1: {
        type: Array,
        default: () => []
      },
      rows2: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: true
      },
      validate: {
        type: Boolean,
        default: false
      },
      noActions: {
        type: Boolean,
        default: true
      },
      rating: {
        type: Object,
        default: () => null
      },
      showRadar: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        gfTemplateConfig: {
          flat: true,
          fillHeight: false,
          fluid: true,
          padding: 'pa-0',
          fieldstyle: 'outlined',
          layoutClass: 'elevation-0 mb-4 mx-0',
          fieldlistClass: 'mb-6',
          disabled: this.disabled,
          fieldlistFocusable: !this.disabled,
          keys: !this.disabled,
          validate: this.validate,
          lazyValidation: false,
          rating: this.rating,
          actions: this.noActions ? null : ['cancel', 'save'],
          rows: []
        },
        callbacks1: {
          onFieldsetToggle: (collapsed, block) => {
            const actionName = $.ns(ATYPES.GFFIELDLIST, this.name + '-2')
            this.$store.dispatch(actionName, {id: block.id, toggle: true, collapsed})
            this.diff = []
            this.delayDiff('1')
            this.delayDiff('2')
          }
        },
        callbacks2: {
          onFieldsetToggle: (collapsed, block) => {
            const actionName = $.ns(ATYPES.GFFIELDLIST, this.name + '-1')
            this.$store.dispatch(actionName, {id: block.id, toggle: true, collapsed})
            this.diff = []
            this.delayDiff('1')
            this.delayDiff('2')
          }
        },
        keyHandler: null,
        radarOptions: {
          scale: {
            animate: true,
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 100,
              stepSize: 10,
              callback(value) {
                return `${value}%`
              }
            },
            pointLabels: {
              callback(value) {
                return value
              },
              fontSize: 12,
              fontStyle: 'normal'
            }
          },
          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                return ` ${value}%  ${$.percentToGrade(value)}`
              }
            }
          }
        },
        radar: null,
        radarDone: false,
        radarVisible: true,
        diff: null
      }
    },

    computed: {
      ...appComputed,
      color() {
        return CONSTANTS.MAIN_BACKGROUND
      }
    },

    watch: {
      rows1: {
        immediate: false,
        handler(rows) {
          this.$gridform[`${this.name}-1`].rows({rows})
          this.radarDone = false
          this.radar = {datasets: [], labels: []}
          this.diff = []
          this.delayDiff('1')
        }
      },
      rows2: {
        immediate: false,
        handler(rows) {
          this.$gridform[`${this.name}-2`].rows({rows})
          this.delayDiff('2')
        }
      },
      disabled() {
        this.$gridform[`${this.name}-1`].config({disabled: this.disabled})
        this.$gridform[`${this.name}-2`].config({disabled: this.disabled})
        if (!this.disabled) this.disableFields()
      },
      showRadar() {
        this.radarVisible = this.showRadar
      },
      radarVisible() {
        this.$emit('radar', this.radarVisible)
      }
    },

    created() {
      this.radarVisible = this.showRadar
    },
    mounted() {
      this._bindKeys()
      this.$nextTick(() => {
        const gf1 = this.$gridform[`${this.name}-1`]
        gf1.config({
          disabled: this.disabled,
          rating: this.rating,
          actions: this.noActions ? null : ['cancel', 'save']
        })
        gf1.rows({rows: this.rows1})
        this.delayDiff('1')

        const gf2 = this.$gridform[`${this.name}-2`]
        gf2.config({
          disabled: this.disabled,
          rating: this.rating,
          actions: this.noActions ? null : ['cancel', 'save']
        })
        gf2.rows({rows: this.rows2})
        this.delayDiff('2')

        if (!this.disabled) this.disableFields()
      })
    },
    beforeDestroy() {
      this._unbindKeys()
    },

    methods: {
      _bindKeys() {
        this.keyHandler = e => {
          if (e.code === 'Escape') this.$emit('close')
        }
        document.addEventListener('keydown', this.keyHandler, true)
      },
      _unbindKeys() {
        document.removeEventListener('keydown', this.keyHandler, true)
      },
      disableFields() {
        this.$gridform[`${this.name}-1`].disable(['username', 'staff', 'employee', 'scriptureUser', 'scriptureStaff', 'scriptureEmployee', 'notes', 'notesPrivate'])
        this.$gridform[`${this.name}-2`].disable(['username', 'staff', 'employee', 'scriptureUser', 'scriptureStaff', 'scriptureEmployee', 'notes', 'notesPrivate'])
      },

      // we must wait before the full coaching is displayed
      // to get correct positions for difference
      delayDiff(rowSet) {
        this.$nextTick(() => {
          _.defer(() => {
            _.delay(() => {
              this.recalcDiff(rowSet)
            }, 600)
          })
        })
      },
      // TODO use calculation from rating.js (v1-4-1)
      recalcDiff(rowSet) {
        const labels = []
        const dataset = []
        const $diff = this.$el.querySelector('.vgfc__container-diff')
        if (!$diff) return

        const diff = this.diff || []
        const diffRect = $diff.getBoundingClientRect()

        let rect
        let rectSum
        let total = 0
        let result = 0
        this.$gridform[`${this.name}-${rowSet}`].fieldlist()
            .filter(group => (group.fieldlist.initials || '').charAt(0) !== '_')
            .filter(group => !_.get(group.fieldlist, 'noRating'))
            .forEach(group => {
          const rating = group.fieldlist.rating
          if (rating) {
            // radar labels
            labels.push(group.fieldlist.initials)
            // radar data
            dataset.push(rating.percent)

            total += rating.max
            result += rating.score

            const id = group.fieldlist.id
            // first coaching
            // query fieldlist and fields, push rating and rect data for compare with second coaching
            if (rowSet === '1') {
              const $vgf = this.$el.querySelector(`#vgf-${this.name}-${rowSet}`)
              const $fh = $vgf.querySelector(`[data-id="${id}"]`)

              // fieldlist exists
              if ($fh) {
                rect = $fh.getBoundingClientRect()
                diff.push({id, top: rect.top - diffRect.top, height: rect.height, score1: rating.score})
              }

              // query fields
              const $rows = $fh ? $fh.nextSibling : $vgf.querySelector(`[data-fl="${id}"]`)
              // rows = <!----> when fieldlist is collapsed
              if (!_.isElement($rows)) return
              if (!$rows.classList.contains('vgf__rows')) return

              // update fieldlist rows
              _.flatten(group.rows).forEach((field, key) => {
                if (field.rating) {
                  const $field = $rows.querySelector(`[data-key="${key}"] > .vgf-f__wrapper`)
                  if ($field) {
                    rect = $field.getBoundingClientRect()
                    diff.push({id: `${id}-${key}`, key: `${key}`, top: rect.top - diffRect.top, height: rect.height, score1: field.rating.score})
                  }
                }
              })
            }
            // second coaching
            // find diff data from first coaching and update data from second
            else {
              // update fieldlist
              let did = diff.find(d => d.id === id)
              if (did) {
                did.score2 = rating.score
                did.diff = did.score2 - did.score1
                did.diff = did.diff > 0 ? `+${did.diff}` : did.diff === 0 ? '=' : `${did.diff}`
              }
              // update fieldlist rows
              _.flatten(group.rows).forEach((field, key) => {
                if (field.rating) {
                  did = diff.find(d => d.id === `${id}-${key}`)
                  if (did) {
                    did.score2 = field.rating.score
                    did.diff = did.score2 - did.score1
                    did.diff = did.diff > 0 ? `+${did.diff}` : did.diff === 0 ? '=' : `${did.diff}`
                  }
                }
              })
              // get rect of sum row
              const $sum = this.$el.querySelector(`#vgf-${this.name}-1 .vgf-f__fab`)
              if ($sum) rectSum = $sum.getBoundingClientRect()
            }
          }
        })

        const percent = (result * 100) / total
        const rgb = $.percentToColor(percent)
        const backgroundColor = $.percentToColor(percent, 0.4)
        const pointBackgroundColor = $.percentToColor(percent, 0.8)

        const datasetOptions = {
          lineTension: 0.1,
          backgroundColor,
          borderColor: rgb,
          pointBackgroundColor,
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 8
        }
        const label = `${result} / ${total} P  ${percent.toFixed(1)}%  ${$.percentToGrade(percent)}`

        // do not update radar every time diff is recalced
        if (!this.radarDone) {
          this.radar = this.radar || {datasets: [], labels}
          const datasets = this.radar.datasets
          datasets.push({label, data: dataset, ...datasetOptions})
          this.radar = Object.assign({}, this.radar, {datasets, labels})
        }

        // second coaching is selected
        // set radar to done, data does not change, do not redraw on every recalc
        // calc diff sum and unshift to diff data
        if (rowSet === '2') {
          this.radarDone = true
          const diffsum = _.reduce(diff, (sum, d) => {
            if (d.key) return sum // count only fieldlist?
            return sum += (d.score2 - d.score1)
          }, 0)
          diff.unshift({
            id: 'diffsum',
            top: rectSum.top - diffRect.top,
            height: 48,
            diff: diffsum > 0 ? `+${diffsum}` : diffsum === 0 ? '=' : `${diffsum}`
          })
        }
        this.diff = diff
      },
      diffStyle(d) {
        return {top: `${d.top}px`, height: `${d.height}px`}
      },

      collapse() {
        const groups = _.groupBy(_.flatten(this.rows1), 'fieldlist.id')
        _.each(groups, (rows, id) => {
          this.$store.dispatch($.ns(ATYPES.GFFIELDLIST, this.name + '-1'), {id, toggle: true, collapsed: true})
          this.$store.dispatch($.ns(ATYPES.GFFIELDLIST, this.name + '-2'), {id, toggle: true, collapsed: true})
        })
        this.diff = []
        this.delayDiff('1')
        this.delayDiff('2')
      },
      expand() {
        const groups = _.groupBy(_.flatten(this.rows1), 'fieldlist.id')
        _.each(groups, (rows, id) => {
          this.$store.dispatch($.ns(ATYPES.GFFIELDLIST, this.name + '-1'), {id, toggle: true, collapsed: false})
          this.$store.dispatch($.ns(ATYPES.GFFIELDLIST, this.name + '-2'), {id, toggle: true, collapsed: false})
        })
        this.diff = []
        this.delayDiff('1')
        this.delayDiff('2')
      }
    }
  }
</script>

<template>
  <VContainer fluid class="vgfc__container pa-0">
    <VSheet elevation="0" class="vgfc__sheet">
      <VToolbar class="vgfc__toolbar" :dense="dense" :color="color" :light="$vuetify.theme.dark" :dark="!$vuetify.theme.dark" :elevation="4">
        <VToolbarTitle>{{ $vuetify.lang.t('$vuetify.compare.title') }}</VToolbarTitle>
        <VSpacer/>
        <VTooltip bottom>
          <template v-slot:activator="{ on }">
            <VBtn icon class="mx-2" v-on="on" @click.left="collapse">
              <VIcon class="mdi mdi-collapse-all-outline"></VIcon>
            </VBtn>
          </template>
          <span>{{ $vuetify.lang.t('$vuetify.compare.actions.collapseAll') }}</span>
        </VTooltip>
        <VTooltip bottom>
          <template v-slot:activator="{ on }">
            <VBtn icon class="mx-2" v-on="on" @click.left="expand">
              <VIcon class="mdi mdi-expand-all-outline"></VIcon>
            </VBtn>
          </template>
          <span>{{ $vuetify.lang.t('$vuetify.compare.actions.expandAll') }}</span>
        </VTooltip>
        <VDivider vertical dark/>
        <VSwitch v-model="radarVisible" :label="$vuetify.lang.t('$vuetify.compare.actions.radar')" class="mx-4" hide-details></VSwitch>
        <VDivider vertical dark/>
        <!-- breakpoint.smAndDown show icon -->
        <VBtn text outlined class="ml-6" @click.left="$emit('close')">
          <span v-if="!$vuetify.breakpoint.smAndDown">{{ $vuetify.lang.t('$vuetify.actions.close') }}</span>
          <VIcon v-else class="mdi mdi-close"></VIcon>
        </VBtn>
      </VToolbar>
      <VRow v-if="radarVisible" class="vgfc__radar mx-0">
        <VCol cols="12">
          <div class="vgfc__container-radar">
            <Radar v-if="!!radar" :chart-data="radar" :options="radarOptions"/>
          </div>
        </VCol>
      </VRow>
      <VRow class="vgfc__diff mx-0">
        <!-- Coaching 1 -->
        <VCol cols="5" class="vgfc__container-1 pa-0">
          <VGridform :name="`${name}-1`" :config="gfTemplateConfig" :callbacks="callbacks1"/>
        </VCol>

        <!-- Diff -->
        <VCol cols="2" class="vgfc__container-diff pa-0">
          <VSheet v-for="d in diff" :key="d.id" :style="diffStyle(d)">
            <div class="vgfc__container-diff-score" :class="{'vgfc__container-diff-score-key': !!d.key, 'vgfc__container-diff-score-sum': d.id === 'diffsum'}">{{ d.diff }}</div>
          </VSheet>
        </VCol>

        <!-- Coaching 2 -->
        <VCol cols="5" class="vgfc__container-2 pa-0">
          <VGridform :name="`${name}-2`" :config="gfTemplateConfig" :callbacks="callbacks2"/>
        </VCol>
      </VRow>
    </VSheet>
  </VContainer>
</template>

<style lang="scss" scoped>
  .vgfc__container {
    height: 100%;
  }
  .vgfc__sheet {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    max-height: 100%;
    overflow: hidden;
  }
  .vgfc__toolbar {
    flex-grow: 0;
  }
  .vgfc__radar {
    background-color: #EFEFEF;
  }
  .vgfc__container-radar {
    display: flex;
    justify-content: center;
    margin: 12px 0 0;
  }
  .vgfc__diff {
    min-height: 0;
    overflow: hidden auto;
  }
  .vgfc__container-1,
  .vgfc__container-2 {
    flex: 0 0 calc(50% - 24px);
    max-width: calc(50% - 24px);
    margin-top: 24px;
  }
  .vgfc__container-diff {
    position: relative;
    flex: 0 0 48px;
    max-width: 48px;
    background: #EFEFEF;
    > .v-sheet {
      position: absolute;
      display: flex;
      align-items: center;
      width: 44px;
      padding: 0 2px;
      margin: 0 2px;
      background: transparent;
      .vgfc__container-diff-score {
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        &.vgfc__container-diff-score-sum {
          font-size: 20px;
        }
        &.vgfc__container-diff-score-key {
          font-size: 16px;
        }
      }
    }
  }
</style>
<style lang="scss">
  /* hide slider in small viewports */
  .app-bp-xs,
  .app-bp-sm {
    .vgfc__diff .vgf-f__wrapper .v-slider {
      display: none;
    }
  }
  .vgfc__diff {
    .vgf__fieldlist:not(.vgf__fieldlist--active) {
      margin-bottom: 0 !important;
    }
  }
</style>
